import { LogoWithText } from '@insify/design-system/logo';
import clsx from 'clsx';

import { SectionHeader } from '../../pages/Shop';

import * as styles from './PartnershipExplained.module.css';

import type { RichContentType } from '../RichContent';

type Props = {
  className?: string;
  content?: RichContentType;
};

export const PartnershipExplained: React.FC<Props> = ({ className, content }) => {
  return (
    <div className={clsx(className, styles.wrapper)}>
      <LogoWithText className={styles.logo} />
      <SectionHeader.Content content={content} />
    </div>
  );
};
